// اللَّهُ لَا إِلَٰهَ إِلَّا هُوَ الْحَيُّ الْقَيُّومُ ۚ لَا تَأْخُذُهُ سِنَةٌ وَلَا نَوْمٌ ۚ
// لَهُ مَا فِي السَّمَاوَاتِ وَمَا فِي الْأَرْضِ ۗ مَنْ ذَا الَّذِي يَشْفَعُ عِنْدَهُ إِلَّا بِإِذْنِهِ ۚ
// يَعْلَمُ مَا بَيْنَ أَيْدِيهِمْ وَمَا خَلْفَهُمْ ۖ وَلَا يُحِيطُونَ بِشَيْءٍ مِنْ عِلْمِهِ إِلَّا بِمَا شَاءَ ۚ
// وَسِعَ كُرْسِيُّهُ السَّمَاوَاتِ وَالْأَرْضَ ۖ وَلَا يَئُودُهُ حِفْظُهُمَا ۚ وَهُوَ الْعَلِيُّ الْعَظِيمُ
// (Bakara 255)

// ui-theme.metadata.json şeması — platform, tenant ve user seviyelerinde kullanılır.
export type ColorMode = 'light' | 'dark' | 'auto';
export type Density = 'compact' | 'comfortable' | 'spacious';
// Görünüm derisi: modern (varsayılan ElpoCore) veya classic (eski portal görünümü). Tek portal,
// tek login, tek özellik seti — yalnızca GÖRÜNÜM değişir. Classic CSS body.skin-classic altında scoped.
export type Skin = 'modern' | 'classic';
export type FontFamily = 'Inter' | 'Outfit' | 'Poppins' | 'Nunito' | 'IBM Plex Sans';

export interface ThemeColors {
  background?: string;
  foreground?: string;
  card?: string;
  cardForeground?: string;
  popover?: string;
  popoverForeground?: string;
  primary?: string;
  primaryForeground?: string;
  secondary?: string;
  secondaryForeground?: string;
  muted?: string;
  mutedForeground?: string;
  accent?: string;
  accentForeground?: string;
  destructive?: string;
  destructiveForeground?: string;
  border?: string;
  input?: string;
  inputBackground?: string;
  ring?: string;
  sidebar?: string;
  sidebarForeground?: string;
  sidebarPrimary?: string;
  sidebarAccent?: string;
  sidebarBorder?: string;
}

export interface ThemeMetadata {
  schemaVersion: 1;
  name?: string;
  skin?: Skin;
  colors?: ThemeColors;
  colorsDark?: ThemeColors;
  radius?: string;
  font?: {
    family?: FontFamily;
    baseSize?: string;
  };
  density?: Density;
  sidebar?: {
    width?: number;
    collapsedWidth?: number;
  };
}

// CSS variable eşleme — ThemeColors alanları :root'a hangi CSS değişkenine yazılacak
export const COLOR_VAR_MAP: Record<keyof ThemeColors, string> = {
  background: '--background',
  foreground: '--foreground',
  card: '--card',
  cardForeground: '--card-foreground',
  popover: '--popover',
  popoverForeground: '--popover-foreground',
  primary: '--primary',
  primaryForeground: '--primary-foreground',
  secondary: '--secondary',
  secondaryForeground: '--secondary-foreground',
  muted: '--muted',
  mutedForeground: '--muted-foreground',
  accent: '--accent',
  accentForeground: '--accent-foreground',
  destructive: '--destructive',
  destructiveForeground: '--destructive-foreground',
  border: '--border',
  input: '--input',
  inputBackground: '--input-background',
  ring: '--ring',
  sidebar: '--sidebar',
  sidebarForeground: '--sidebar-foreground',
  sidebarPrimary: '--sidebar-primary',
  sidebarAccent: '--sidebar-accent',
  sidebarBorder: '--sidebar-border',
};

export const DENSITY_BASE_SIZE: Record<Density, string> = {
  compact: '13px',
  comfortable: '14px',
  spacious: '15px',
};

// İki metadata'yı birleştir: override > base.
export function mergeTheme(base: ThemeMetadata, override: Partial<ThemeMetadata>): ThemeMetadata {
  return {
    schemaVersion: 1,
    name: override.name ?? base.name,
    skin: override.skin ?? base.skin,
    radius: override.radius ?? base.radius,
    density: override.density ?? base.density,
    font: { ...base.font, ...override.font },
    sidebar: { ...base.sidebar, ...override.sidebar },
    colors: { ...base.colors, ...override.colors },
    colorsDark: { ...base.colorsDark, ...override.colorsDark },
  };
}
